import {
    Component, EventEmitter,
    Input, OnInit, Output,
    ViewEncapsulation
} from '@angular/core';
import { SubscriptionModel } from '../../../../shared/models/subscription.model';
import { ClientModel } from '../../../../shared/models/client.model';
import { AuthenticatedUserRepositoryService } from '../../../../payment/services/authenticated-user-repository.service';

@Component({
    selector: 'account-subscriptions-details-actions',
    templateUrl: './account.subscriptions.details.actions.component.html',
    styleUrls: ['./../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountSubscriptionsDetailsActionsComponent implements OnInit {
    @Input('subscription') subscription: SubscriptionModel;
    @Input('isActive') isActive: boolean;
    @Input('isInactive') isInactive: boolean;
    @Input('showAddressUpdate') showAddressUpdate = false;
    @Input('showCancel') showCancel = false;
    @Output('updated') updated: EventEmitter<any> = new EventEmitter();

    public client: ClientModel;
    public loading = false;

    constructor(
        protected authenticatedUserRepository: AuthenticatedUserRepositoryService
    ) { }

    ngOnInit () {
        this.client = this.authenticatedUserRepository.getUser();
    }

    public update() {
        this.updated.emit();
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2078029388/src/src/app/account/subscriptions/details/actions/account.subscriptions.details.actions.component.ts